import { ApiClient } from "@/api-client/src";

const apiClient = new ApiClient();
const webService = apiClient.web;

/**
 * Send contact message through the Contact Us form
 */
export const contactThroughMessage = async (data: {
  name: string;
  email: string;
  subject: string;
  message: string;
  captchaToken?: string | null;
}): Promise<void> => {

  try {
    const response = await webService.post<void>("/contact-us", data);
    return response;
  } catch (error) {
    console.error("Failed to send contact message:", error);
    throw error;
  }
};
